import { useAuth } from '../contexts/AuthContext';

/**
 * Custom hook to apply branch filtering for branch managers
 * Returns the branch ID to filter by, or null if admin (sees all)
 */
export const useBranchFilter = () => {
  const { isAdmin, getUserBranchId } = useAuth();

  // Admin sees all data, branch managers see only their branch
  const branchId = isAdmin() ? null : getUserBranchId();

  return {
    branchId,
    shouldFilter: !isAdmin(),
    isAdmin: isAdmin(),
  };
};

/**
 * Apply branch filter to API query parameters
 */
export const applyBranchFilter = (params, branchId) => {
  if (!branchId) return params;
  return { ...params, branch_id: branchId };
};

export default useBranchFilter;

